import { useEffect, useState } from "react";

// Dominios de tus acortadores. Si vienes de cualquiera de estos, se
// considera que pasaste el checkpoint. Sepáralos con coma en
// REACT_APP_CHECKPOINT_DOMAINS si quieres cambiar la lista.
const CHECKPOINT_DOMAINS = (
  process.env.REACT_APP_CHECKPOINT_DOMAINS ||
  "linkvertise.com,link-to.net,link-center.net,lootlabs.gg,loot-link.com,work.ink"
)
  .split(",")
  .map((d) => d.trim().toLowerCase())
  .filter(Boolean);

const SESSION_FLAG = "mrh_gate_ok_at";
const SESSION_TTL_MS = 10 * 60 * 1000; // 10 min para usar el dashboard tras pasar el checkpoint

function cameFromCheckpoint() {
  try {
    const ref = document.referrer.toLowerCase();
    if (!ref) return false;
    return CHECKPOINT_DOMAINS.some((domain) => ref.includes(domain));
  } catch {
    return false;
  }
}

function hasFreshSession() {
  const raw = sessionStorage.getItem(SESSION_FLAG);
  if (!raw) return false;
  const ts = parseInt(raw, 10);
  if (Number.isNaN(ts)) return false;
  return Date.now() - ts < SESSION_TTL_MS;
}

function markSession() {
  sessionStorage.setItem(SESSION_FLAG, String(Date.now()));
}

// Hook: devuelve true solo si el usuario llegó legítimamente
// (referido por el checkpoint, o ya tiene sesión reciente marcada).
// Si no, false — la pantalla que lo use debe mostrar un bloqueo.
export function useGate() {
  const [allowed, setAllowed] = useState(null); // null = comprobando

  useEffect(() => {
    if (hasFreshSession()) {
      setAllowed(true);
      return;
    }
    if (cameFromCheckpoint()) {
      markSession();
      setAllowed(true);
      return;
    }
    setAllowed(false);
  }, []);

  return allowed;
}

// Efecto puramente visual: va reescribiendo un parámetro sin
// sentido en la barra de direcciones para que un enlace copiado
// en ese instante no sirva de nada compartido más tarde.
// NO es la validación real (esa la hace useGate arriba), es solo
// para que no se vea un link "limpio y compartible".
export function useCosmeticRotatingUrl(enabled) {
  useEffect(() => {
    if (!enabled) return;
    const interval = setInterval(() => {
      const noise = Math.random().toString(36).slice(2, 12);
      const url = `${window.location.pathname}?PS=${noise}`;
      window.history.replaceState({}, "", url);
    }, 700);
    return () => clearInterval(interval);
  }, [enabled]);
}
